// Angular
import { Injectable } from '@angular/core';
// RxJS
import { BehaviorSubject } from 'rxjs';
// Object path
import * as objectPath from 'object-path';
// Services
import { MenuConfigService } from './menu-config.service';
import { ApiService } from './../../../../api.service';

@Injectable()
export class MenuAsideService {
	// Public properties
	classes: string;
	menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

	/**
	 * Service Constructor
	 *
	 * @param menuConfigService: MenuConfigService
	 * @param store: Store<AppState>
	 */
	constructor(
		private menuConfigService: MenuConfigService,
		private cs: ApiService
	) {

		this.getRole();
	}

	/**
	 * Load menu
	 */
	loadMenu() {
		const menuItems: any[] = objectPath.get(this.menuConfigService.getMenus(), 'aside.items');
		const menus: any[] = [];
		let hasLogout = false;
	  
		menuItems.forEach(element => {
			if (element.title === 'Customer Cancel Reasons') {
				menus.push(element);
			}
			// else if (element.title === 'Users Reports') {
			// 	menus.push(element);
			// } 
			else if (element.title === 'Notifications') {
				menus.push(element);
			} 
			else if (element.title === 'Zones') {
				menus.push(element);
			} 
			else if (element.title === 'Logout' && !hasLogout) {
			menus.push(element);
			hasLogout = true;
		  } else {
			const menu = this.roleSettings.menu.find(e => e.title == element.title);
			if (menu && menu.permissions.view) {
			  menus.push(element);
			}
		  }
		});
	
		this.menuList$.next(menus);
	  }
	  
	
	
	roleSettings = { menu: [] };


	getRole() {
		let params = { 'filter': { 'where': { 'role': localStorage.getItem('role') } } };
		this.cs.httpService('get', 'AdminRoles/findOne', params).subscribe(data => {
			this.roleSettings = data;
			this.loadMenu();
		});
	}
}